<template>
  <div class="elasticComputeCloudResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <div>
        <Col span="6" v-if="companyIdShow == 1">
          <Select
            v-model="companyId"
            @on-change="changeCompanyID"
            placeholder="公司"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <!--按账户id筛选  -->
          <Select
            v-model="accountSearchKey"
            filterable
            multiple
            :max-tag-count="1"
            placeholder="请输入账户"
            @on-change="changeAccountId(accountSearchKey)"
            :transfer="true"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block; text-align: right"
              v-if="accountList.length > 0"
              >{{ $t("alarms.common.allSelected") }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <!--按账户名称筛选  -->
        <Col span="6">
          <Input
            v-model="accountName"
            :placeholder="$t('RAM.common.filterByAccountName')"
          />
        </Col>
      </div>
    </Row>
    <Row :gutter="4">
      <Col span="6">
        <!-- 条件名称  -->
        <Select
          v-model="instanceField"
          filterable
          placeholder="条件名称"
          @on-change="searchInstanceField()"
          :transfer="true"
        >
          <Option
            :value="item.name"
            v-for="item in instanceFieldList"
            :key="item.id"
            >{{ item.chineseName }}</Option
          >
        </Select>
      </Col>
      <Col span="6">
        <!-- 条件值  -->
        <Select
          ref="selectTextT"
          v-model="instanceByfield"
          filterable
          clearable
          placeholder="条件值"
          :transfer="true"
        >
          <Option
            :value="item.name"
            v-for="item in instanceByfieldList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Button
        v-hasPermission="[
          'resourceConfigurationManagement:aws:elasticComputeCloudResource:add'
        ]"
        @click="add()"
        >{{ $t("alarms.common.add") }}</Button
      >
      <Button
        v-hasPermission="[
          'resourceConfigurationManagement:aws:elasticComputeCloudResource:page'
        ]"
        @click="search()"
        >{{ $t("alarms.common.search") }}</Button
      >
    </Row>

    <Row :gutter="4">
      <Tag
        v-for="item in queryList"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2($event, item)"
        >{{ item }}</Tag
      >
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
export default {
  name: "ElasticComputeCloudResourceSearch",
  // 接受父组件的值
  props: {
    ecColumns: Array
  },
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      selectTextT: "",
      companyIdList: [],
      accountSearchKey: [],
      singleAccount: false,
      accountList: [],
      accountName: "",
      instanceField: "",
      instanceFieldList: [],
      instanceByfield: "",
      instanceByfieldList: [],
      queryList: []
    };
  },
  mounted: function() {
    if (this.companyIdShow == 1) {
      this.listRegisterInformation();
    } else {
      this.$parent.showAll();
    }
    this.selectInstanceField();
  },
  methods: {
    getCurVal(val) {
      this.value = val.target.value;
    },
    //查询账号
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountSearchKey = [];
        this.getAWSAccountByCompanyId();
      });
    },
    getAWSAccountByCompanyId: function() {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountSearchKey.push(this.accountList[i].id);
            }
          }
        });
    },
    // 切换公司
    changeCompanyID: function() {
      this.accountSearchKey = [];
      this.getAWSAccountByCompanyId();
    },
    // 切换账户
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },

    selectAccountAll() {
      this.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountSearchKey.push(item.id);
        });
      } else {
        this.accountSearchKey = [];
      }
    },
    selectInstanceField: function() {
      this.$api.instance.selectInstanceField().then(res => {
        this.instanceFieldList = res.data;
      });
    },
    searchInstanceField() {
      this.queryInstanceByfield();
    },
    queryInstanceByfield: function() {
      this.$api.instance
        .queryInstanceByfield({
          companyId: this.companyId,
          accountIdList: this.accountSearchKey,
          name: this.instanceField
        })
        .then(res => {
          this.instanceByfieldList = res.data;
        });
    },
    add: function() {
      var count = true;
      for (let i = 0, length = this.queryList.length; i < length; i++) {
        var keyy = this.queryList[i].split("=")[0];
        if (keyy == this.instanceField) {
          count = false;
          this.$Message.error("你已选择该条件名称");
          break;
        }
      }
      if (count == true) {
        this.handleAdd(this.instanceField + "=" + this.instanceByfield);
      }
    },
    search: function() {
      this.$parent.companyId = this.companyId
      this.$parent.accountName = this.accountName
      this.$parent.accountSearchKey = this.accountSearchKey
      this.$parent.queryList = this.queryList
      this.$parent.showAll();
    },
    handleAdd(val) {
      this.queryList.push(val);
    },
    handleClose2(event, name) {
      const index = this.queryList.indexOf(name);
      this.queryList.splice(index, 1);
      this.$refs.selectTextT.clearSingleSelect();
    }
  }
};
</script>
<style scoped>
.elasticComputeCloudResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ec2/ElasticComputeCloudResourceSearch.vue